
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as TemporaryHome16Vagc_pB7JX8vYYbsRY35AoLNQ6Oi1QpiEV9N_QdpAMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/TemporaryHome.vue?macro=true";
import { default as BonusGiftsViewpZGLN9z3v5YR75haGQsIc2rgO_zlNowCBPVL_NZO7LsMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/BonusGiftsView.vue?macro=true";
import { default as RegistrantView_f5HXiZ4_4_qc1JAuHYCS09_HMRvAyGm_IuIF5sPf80Meta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistrantView.vue?macro=true";
import { default as LinkRegistryViewwI48YE_IjxkC8TK2MKBev_HDIk0_CvZNtCgFnmlMthQMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/LinkRegistryView.vue?macro=true";
import { default as CreateRegistryViewnesVL53QMsBtGFkc6cZoJ79ZK_2nsLeSduyBisAC2dMMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/CreateRegistryView.vue?macro=true";
import { default as SearchRegistryViewm3DXKUu6Aos9F6_CZAmw0_yakbnl6UTkAU5M59UQ5rgMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/SearchRegistryView.vue?macro=true";
import { default as RegistrySettingsViewtevgxu3OTX5oxldMilD99lbrNkF8lGZROIz1A_ZQSw0Meta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistrySettingsView.vue?macro=true";
import { default as GiftGiverRegistryViewdIeNf1P_fYRnQQsMhDRphp5p9hOeb_C9d3B6Z5EaGR0Meta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/GiftGiverRegistryView.vue?macro=true";
import { default as RegistryCommonLandingViewR0JojUAP6_LwbTnl5ULjpXW4jVr2FdATJs2XZDZotUsMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistryCommonLandingView.vue?macro=true";
import { default as RegistryOccasionLandingView5pgb6ZODQ7j1Ty8NSGHSLc4T4nUHDoxCkqY6Y7g2fzQMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistryOccasionLandingView.vue?macro=true";
import { default as RegistrantHomeTabmO2PC6_NWBUDb2aRP82l50vVk5Ez1SMZOUcDOqO7mvMMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantHomeTab.vue?macro=true";
import { default as RegistrantMyGiftTabyZrZZkjSl_K5ddZdRxVlHgcDF5R_EyWRopMpZzZwMQgMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantMyGiftTab.vue?macro=true";
import { default as RegistrantBenefitTab2Per1jORwc5cBVbnNOYUiHR4e18aM0i6hY5OyrZAGBsMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantBenefitTab.vue?macro=true";
import { default as RegistrantGiftTrackerTabXn0wJmSGNJKbn_Fc32RpPyXp1q3ofP0LQWGD04bY2tYMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantGiftTrackerTab.vue?macro=true";
import { default as component_45stubs7x3Cd0gqZitJxGQckqsYXQcqFhkE18r8ScuufOn2zkMeta } from "/builds/macys/polaris/nuxt-app/registry-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubs7x3Cd0gqZitJxGQckqsYXQcqFhkE18r8ScuufOn2zk } from "/builds/macys/polaris/nuxt-app/registry-ui/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "TemporaryHome",
    path: "/TemporaryHome",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/TemporaryHome.vue")
  },
  {
    name: "BonusGiftsView",
    path: "/BonusGiftsView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/BonusGiftsView.vue")
  },
  {
    name: "RegistrantView",
    path: "/RegistrantView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistrantView.vue")
  },
  {
    name: "LinkRegistryView",
    path: "/LinkRegistryView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/LinkRegistryView.vue")
  },
  {
    name: "CreateRegistryView",
    path: "/CreateRegistryView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/CreateRegistryView.vue")
  },
  {
    name: "SearchRegistryView",
    path: "/SearchRegistryView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/SearchRegistryView.vue")
  },
  {
    name: "RegistrySettingsView",
    path: "/RegistrySettingsView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistrySettingsView.vue")
  },
  {
    name: "GiftGiverRegistryView",
    path: "/GiftGiverRegistryView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/GiftGiverRegistryView.vue")
  },
  {
    name: "RegistryCommonLandingView",
    path: "/RegistryCommonLandingView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistryCommonLandingView.vue")
  },
  {
    name: "RegistryOccasionLandingView",
    path: "/RegistryOccasionLandingView",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/RegistryOccasionLandingView.vue")
  },
  {
    name: "registrantTabs-RegistrantHomeTab",
    path: "/registrantTabs/RegistrantHomeTab",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantHomeTab.vue")
  },
  {
    name: "registrantTabs-RegistrantMyGiftTab",
    path: "/registrantTabs/RegistrantMyGiftTab",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantMyGiftTab.vue")
  },
  {
    name: "registrantTabs-RegistrantBenefitTab",
    path: "/registrantTabs/RegistrantBenefitTab",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantBenefitTab.vue")
  },
  {
    name: "registrantTabs-RegistrantGiftTrackerTab",
    path: "/registrantTabs/RegistrantGiftTrackerTab",
    component: () => import("/builds/macys/polaris/nuxt-app/registry-ui/app/pages/registrantTabs/RegistrantGiftTrackerTab.vue")
  },
  {
    name: component_45stubs7x3Cd0gqZitJxGQckqsYXQcqFhkE18r8ScuufOn2zkMeta?.name,
    path: "/",
    component: component_45stubs7x3Cd0gqZitJxGQckqsYXQcqFhkE18r8ScuufOn2zk
  }
]